import { useTranslation } from "react-i18next";
import "../styles/Legal.css";

export default function CookiesPolicy() {
  const { t } = useTranslation();

  const sections = t("cookies.sections", { returnObjects: true });

  return (
    <main className="legal-container no-copy">
      <h1>{t("cookies.title")}</h1>

      {Array.isArray(sections) &&
        sections.map((section, index) => (
          <section key={index}>
            <h2>{section.title}</h2>

            {section.text && <p>{section.text}</p>}

            {Array.isArray(section.items) && (
              <ul>
                {section.items.map((item, itemIndex) => (
                  <li key={itemIndex}>{item}</li>
                ))}
              </ul>
            )}
          </section>
        ))}
    </main>
  );
}